import React, { useState, useEffect } from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FunnelPic from '../../Images/FunnelPic.png'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { getAgentDashboardDetailById,getSalesLeadconversionById } from '../../CommunityActionCreator';
import moment from 'moment';
const blockcss = {
    display: "block",
    alignItems: "center",
    marginTop: "20px",
    background: "rgb(255, 255, 255)",
    padding: "20px",
    borderRadius: "6px",
    boxShadow: "rgb(238, 238, 238) 3px 3px 10px 1px",
    height: "auto",

}

const data = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];


export default function SalesAgentDashboard({Detaildata}) {
    const [stats,setStats] =useState({});
    const [listData,setListData] =useState([])
    const [payload,setPayload] =useState({
        sDate:moment(new Date).format("YYYY-MM-DD"),
        eDate:moment(new Date).format("YYYY-MM-DD"),
        filterType:"daily"
    })


    useEffect(()=>{
        getAgentDashboardDetailByIdFn(payload)
        getSalesLeadconversionByIdFn(payload)
    },[])

    const handleChnage =(e,type)=>{
       
        if(type == "filterType"){
            const obj = {
                ...payload,
                "filterType":e.target.value
            }
            setPayload(obj)
             getSalesLeadconversionByIdFn(obj)

        }else{
             setPayload((pre)=>({
            ...pre,
            [type]:e.target.value
        }))
        }
    }

    const handleApply =()=>{
         getAgentDashboardDetailByIdFn(payload)
         getSalesLeadconversionByIdFn(payload)
    }

    const getAgentDashboardDetailByIdFn = (d)=>{
        const s = moment(d.sDate).format("DD-MM-YYYY");
        const e = moment(d.eDate).format("DD-MM-YYYY");
        const obj = {
            communityId:Detaildata?.communityId,
            sDate:s,
            eDate:e
        }
        getAgentDashboardDetailById(obj,callback=>{
            console.log(callback)
            if(callback?.status == 200 && callback?.message == "success"){
                setStats(callback?.data)
            }else{
                setStats({})
            }
        })
    }
    const getSalesLeadconversionByIdFn = (d)=>{
        const s = moment(d.sDate).format("DD-MM-YYYY");
        const e = moment(d.eDate).format("DD-MM-YYYY");
        const obj = {
            communityId:Detaildata?.communityId,
            sDate:s,
            eDate:e,
            filterType:d?.filterType
        }
        getSalesLeadconversionById(obj,callback=>{
            console.log(callback)
            if(callback?.status == 200 && callback?.message == "success"){
                setListData(callback?.data)
            }else{
                setListData([])
            }
        })
    }
    return (
        <>
            <div className="row">
                <div className="col-sm-2 col-xs-4">
                    <label htmlFor="">Start Date</label>
                    <input type='date' className='form-control' value={payload?.sDate} onChange={(e)=>handleChnage(e,"sDate")}/>
                </div>
                <div className="col-sm-2 col-xs-4">
                    <label htmlFor="">End Date</label>
                    <input type='date' className='form-control' value={payload?.eDate} onChange={(e)=>handleChnage(e,"eDate")}/>
                </div>
                <div className="col-sm-2 col-xs-4">
                   <button className='btn btn-primary' style={{marginTop:'22px',padding:'11px'}}onClick={()=>handleApply()}>Apply</button>
                </div>
            </div>

            <hr />

            <div className="row">
                <div className="col-sm-4 col-xs-12">
                    <div style={{ ...blockcss, textAlign: 'center', height: '300px' }}>
                        <AccountCircleIcon style={{ width: '35%', height: "35%", color: 'grey' }} />

                        <h3 style={{ margin: '5px 0' }}>{stats?.communityName || ""}</h3>
                        <div style={{ marginTop: '15px' }}>
                            <h5 style={{ margin: '15px 0' }}><b>Dealer Name : </b><span style={{ color: 'grey' }}>234231678</span></h5>
                            <h5 style={{ margin: '15px 0' }}><b>Region / Branch : </b><span style={{ color: 'grey' }}>{stats?.communityCity || ""}  /  {stats?.communityState || ""}</span></h5>
                            <h5 style={{ margin: '15px 0' }}><b>Status : </b><span style={{ color: '#fff', padding: '3px 10px', background:stats?.status == true ? 'green' : "red", borderRadius: '5px' }}>{stats?.status == true ? "Active" : "Inactive"}</span></h5>
                            <h5 style={{ margin: '15px 0' }}><b>Total Lead Assigned : </b><span style={{ color: 'grey' }}>{stats?.communityStats?.assigned || 0}</span></h5>
                        </div>
                    </div>
                </div>
                <div className="col-sm-8 col-xs-12">
                    <div style={{ ...blockcss, height: '300px' }}>
                        <h4>Performance Summary</h4>
                        <hr style={{ margin: '8px 0 15px 0' }} />
                        <h5 style={{ fontSize: '16px', padding: '8px 0' }}>Leads Contacted : &nbsp;<span style={{ color: 'grey' }}>{stats?.communityStats?.contacted || 0}</span></h5>
                        <h5 style={{ fontSize: '16px', padding: '8px 0' }}>Leads Converted : &nbsp;<span style={{ color: 'grey' }}>{stats?.communityStats?.converted || 0}</span></h5>
                        <h5 style={{ fontSize: '16px', padding: '8px 0' }}>Conversion Rate (%) : &nbsp;<span style={{ color: 'grey' }}>{stats?.communityStats?.conversionRate || 0 + "%"}</span></h5>
                        <h5 style={{ fontSize: '16px', padding: '8px 0' }}>Pending Leads : &nbsp;<span style={{ color: 'grey' }}>{stats?.communityStats?.leadPending || 0}</span></h5>
                        <h5 style={{ fontSize: '16px', padding: '8px 0' }}>Avg. TAT (Time to Convert Lead) : &nbsp;<span style={{ color: 'grey' }}>{stats?.communityStats?.avgTat || 0}</span></h5>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-3 col-xs-12">
                    <div style={{ ...blockcss }}>
                        <h4>Funnel</h4>
                        <hr style={{ margin: '8px 0 15px 0' }} />
                        <div style={{ textAlign: 'center' }}>
                            <img src={FunnelPic} alt='Funnel' width={"70%"} />
                        </div>
                    </div>
                </div>
                <div className="col-sm-9 col-xs-12">
                    <div style={{ ...blockcss }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <h4>Leads Assigned vs Converted</h4>
                            <select style={{ border: "none" }} onChange={(e)=>handleChnage(e,"filterType")} value={payload?.filterType}>
                                <option value="daily">Daily</option>
                                <option value="weekly">Weekly</option>
                                <option value="monthly">Monthly</option>
                            </select>
                        </div>

                        <hr style={{ margin: '8px 0 15px 0' }} />
                        <div style={{height:'300px'}}>
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart
                                    width={500}
                                    height={300}
                                    data={listData}
                                    barSize={10}
                                    margin={{
                                        top: 5,
                                        right: 20,
                                        left: 10,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid vertical={false} strokeDasharray="4 4" />
                                    <XAxis dataKey="key" tickLine={false} />
                                    <YAxis tickLine={false} axisLine={false} />
                                    <Tooltip />
                                    <Legend
                                    verticalAlign="bottom" />
                                    <Bar dataKey="leadsAssigned" fill="#014C60"  />
                                    <Bar dataKey="converted" fill="#FF8158"  />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
